import { FC } from 'react';
import useTimerProgress from '@/features/poker-table/hooks/useTimerProgress';
import { twMerge } from 'tailwind-merge';
import useIsMobileView from '@/hooks/useIsMobileView';

const colorClasses: Record<string, string> = {
  'ph-gray-cod-light': 'stroke-ph-gray-cod-light text-ph-gray-cod-light',
  'ph-orange': 'stroke-ph-orange text-ph-orange',
  'ph-red-secondary': 'stroke-ph-red-secondary text-ph-red-secondary',
};

interface TableHeaderTimeCounterProps {
  timer?: number;
  timeRemaining?: number;
  className?: string;
}

const TimeBankTimer: FC<TableHeaderTimeCounterProps> = ({ timer, timeRemaining, className }) => {
  const isMobileView = useIsMobileView();
  const { progressBarWidth } = useTimerProgress({
    timer,
    timeRemaining,
  });

  if (timer === undefined) {
    return null;
  }

  const radius = 18;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - parseFloat(progressBarWidth) / 100);

  let progressColor: keyof typeof colorClasses = 'ph-gray-cod-light';

  if (parseFloat(progressBarWidth) <= 50 && parseFloat(progressBarWidth) > 10) {
    progressColor = 'ph-orange';
  } else if (parseFloat(progressBarWidth) <= 10) {
    progressColor = 'ph-red-secondary';
  }

  return (
    <div className={twMerge('relative flex items-center justify-center', 'h-[2.5em] w-[2.5em]', className)}>
      <svg className="absolute rotate-90 scale-x-[-1] transform" width="100%" height="100%" viewBox="0 0 40 40">
        <circle className="strok-2 fill-ph-background-dark" cx="20" cy="20" r={radius} />
        <circle
          className={twMerge('fill-none stroke-2', colorClasses[progressColor] ? colorClasses[progressColor] : '')}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          cx="20"
          cy="20"
          r={radius}
        />
      </svg>
      <span
        className={twMerge(
          'z-10 font-manrope text-base font-semibold leading-none md:text-sm',
          colorClasses[progressColor],
        )}
      >
        {timeRemaining && timeRemaining > 0 ? `${timeRemaining}s` : `Fold`}
      </span>
    </div>
  );
};

export default TimeBankTimer;
